import { buildEnvironmentFilters } from 'src/apps/dashboard/services/queries/dashboard/helpers/environmentFilterBuilder';
import { IFilterOptions } from 'src/common/helpers/DataFilterHelper';
import {
	calculateRecentPeriodDates,
	formatDateForGraphQL
} from 'src/common/helpers/DateFormatHelper';

import { BusinessUnitsTableDataQueryVariables } from '../BusinessUnitsTable.generated';

interface IBusinessUnitsTableParams {
	days: number;
	filters?: IFilterOptions;
}

export const buildBusinessUnitsTableVariables = ({
	days,
	filters
}: IBusinessUnitsTableParams): BusinessUnitsTableDataQueryVariables => {
	const { today: todayDate, recentPeriodStart } = calculateRecentPeriodDates(days);
	const environmentConfig = buildEnvironmentFilters(filters);

	return {
		days,
		calculationDateFrom: { value: [formatDateForGraphQL(recentPeriodStart)] },
		calculationDateTo: { value: [formatDateForGraphQL(todayDate)] },
		...(environmentConfig?.scoreFilter && {
			environmentFilter: environmentConfig.scoreFilter
		})
	};
};
